<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content [noPadding]="true">
  <data-table (detail)="onDetail($event)" [columns]="columns" [dataProviderParams]="params" [dataProvider]="errorlogService"
              [title]="title"></data-table>
</page-content>
